import React, {FormEvent, useCallback, useEffect, useState} from 'react'
import useApi from '../../hooks/useApi'
import Modal from '../../Korbantech/components/Modal'
import {Osc} from '../../types/Osc'
import {SpinnerLoad} from '../Loading/SpinnerLoad'
import {ApproveOsc} from './ApproveOsc'
import {FiltersOsc} from './FiltersOsc'
import {GeneralDataFields} from "../OscForm/OscFields/GeneralDataFields";
import {ContactFields} from "../OscForm/OscFields/ContactFields";
import {ActuationAndPublic} from "../OscForm/OscFields/ActuationAndPublic";
import {StructOrganizationFields} from "../OscForm/OscFields/StructOrganizationFields";
import {LogoAndDescription} from "../OscForm/OscFields/LogoAndDescriptionFields";

export const ListOsc = ({noApproved, filter}: Props) => {

    const api = useApi()
    const [oscs, setOscs] = useState<Osc[]>()
    const [load, setLoad] = useState<boolean>(false)
    const [osc, setOsc] = useState<Osc>()
    const [modal, setModal] = useState<boolean>()
    const [modalDelete, setDeleteModalOpen] = useState<boolean>(false)
    const [edit, setEdit] = useState<boolean>(false)

    const loadOscs = useCallback(async () => {
        setLoad(true);
        await api.get(`admin/osc${noApproved ? '/no-approved' : ""}`).then(res => {
            setOscs(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [api, noApproved])

    const approve = useCallback(async (id: number) => {
        setLoad(true);
        await api.patch(`admin/osc/${id}`).then(res => {
            loadOscs()
        }).catch(console.log)
        setModal(false)
        setLoad(false)
    }, [api, loadOscs])

    const reprove = useCallback(async (id: number) => {
        setLoad(true);
        await api.patch(`admin/osc/reprove/${id}`).then(res => {
            loadOscs()
        }).catch(console.log)
        setModal(false)
        setLoad(false)
    }, [api, loadOscs])

    const remove = useCallback(async (id: number) => {
        setLoad(true);
        await api.delete(`admin/osc/${id}`).then(res => {
            console.log(res);
        }).catch(console.log)
        setModal(false)
        setLoad(false)
    }, [api])

    const openOscModal = useCallback((currentOsc: Osc) => {
        setOsc(currentOsc)
        setModal(true)
    }, [setModal, setOsc])

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        setLoad(true);
        e.preventDefault()
        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)
        await api.get("/admin/osc", {data}).then(res => {
            setOsc(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [api])

    useEffect(() => {
        loadOscs();
    }, [loadOscs])


    return (
        <div>
            <form onSubmit={handleSubmit}>
                {filter &&
                    <FiltersOsc/>
                }
            </form>
            <div className='grid grid-cols-10  text-gray-700'>
                <div className='col-span-2 p-2 font-bold'>OSC</div>
                <div className='col-span-2 p-2 font-bold'>Causa</div>
                <div className='col-span-2 p-2 font-bold'>Região</div>
                <div className='col-span-2 p-2 font-bold'>Cidade</div>
                {!noApproved && <>
                    <div className='col-span-1 p-2 font-bold text-center'>Testes</div>
                    <div className='col-span-1 p-2 font-bold text-center'>Nota</div>
                </>}
            </div>
            {load && <div className='mt-2'><SpinnerLoad/></div>}
            {!load &&
                <div className='bg-white'>
                    {
                        oscs?.map(item => (
                            <div key={item.id}
                                 className={`grid grid-cols-10 text-gray-700 ${item.id % 2 === 0 && "bg-gray-50"}`}
                                 onClick={!noApproved ? () => openOscModal(item) : () => {
                                 }}>

                                <div className='col-span-2 p-2'>{item.corporate_name}</div>
                                <div className='col-span-2 p-2'>{item.primary_cause?.name}</div>
                                <div className='col-span-2 p-2'>{item.location?.region}</div>
                                <div className='col-span-2 p-2'>{item.location?.city}</div>
                                {!noApproved && <>
                                    <div className='col-span-1 p-2 text-center'>{item.osc_diagnoses?.length}</div>
                                    <div className='col-span-1 p-2 text-center'>{(item.average)?.toFixed(1)}</div>
                                </>}
                                {noApproved &&
                                    <div className='p-2'>
                                        <button onClick={() => openOscModal(item)}
                                                className='border-2 border-gray-300 bg-white rounded-md py-1 px-3'>
                                            Aprovar
                                        </button>
                                    </div>}
                            </div>
                        ))
                    }
                </div>

            }
            <Modal open={modal} onClickCloseButton={() => setModal(false)}>
                <div className='flex flex-col '>

                    {!load && edit && osc &&
                        <div>
                            <div className='bg-gray-100 p-2 shadow-lg flex flex-col'>
                                <GeneralDataFields oldData={osc} update/>
                                <hr/>
                                <ContactFields oldData={osc} update/>
                                <ActuationAndPublic oldData={osc} update/>
                                <StructOrganizationFields oldData={osc} update/>
                                <LogoAndDescription oldData={osc} update/>
                            </div>
                            <button className='bg-primary px-2 py-1 rounded-md' onClick={() => setEdit(false)}>Voltar
                            </button>
                        </div>
                    }

                    {!edit && osc && <>
                        <ApproveOsc currentOsc={osc}/>
                        {
                            !noApproved && osc &&
                            <div className='w-full flex justify-between px-4'>
                                <div className='flex gap-x-3'>
                                    <button onClick={() => setEdit(true)}
                                            className='border-2 border-gray-300 bg-green-500  text-white font-bold rounded-md py-3 px-6'>
                                        Editar
                                    </button>
                                    <button onClick={() => setDeleteModalOpen(true)}
                                            className='border-2 border-gray-300 bg-primary font-bold rounded-md py-3 px-6'>
                                        Apagar
                                    </button>
                                </div>
                            </div>
                        }
                        {
                            noApproved && osc &&
                            <div className='w-full flex justify-between px-4'>
                                <button onClick={() => setModal(false)}
                                        className='border-2 border-gray-300 bg-red-600 text-white font-bold rounded-md py-3 px-6'>
                                    Fechar
                                </button>
                                <div className='flex gap-x-3'>
                                    <button onClick={() => reprove(osc.id)}
                                            className='border-2 border-gray-300 bg-primary font-bold rounded-md py-3 px-6'>
                                        Reprovar
                                    </button>
                                    <button onClick={() => approve(osc.id)}
                                            className='border-2 border-gray-300 bg-green-500  text-white font-bold rounded-md py-3 px-6'>
                                        Aprovar
                                    </button>
                                </div>
                            </div>
                        }
                    </>}
                </div>
            </Modal>
            <Modal open={modalDelete} onClickCloseButton={() => setDeleteModalOpen(false)}>
                {osc &&
                    <form className="flex flex-col">
                        Tem certeza que deseja deletar a OSC "{osc.corporate_name}"?
                        <button onClick={() => remove(osc.id)}
                                className='bg-red-500 rounded py-1 px-2 mt-2 self-end text-white'>Deletar</button>
                    </form>
                }
            </Modal>
        </div>
    )
}

interface Props {
    noApproved?: boolean,
    filter?: boolean
}
